import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocaleService {
  private localeData: { [key: string]: string } = {};
  private readonly dataUrlPattern = /data:[^'")\s]+/gi;
  private readonly dataUrlPlaceholderPattern = /__BRAND_SAFE_DATA_URL_(\d+)__/g;

  /**
   * 设置多语言数据
   *
   * @param data
   */
  setLocaleData(data: { [key: string]: string }) {
    this.localeData = data || {};
  }

  /**
   * 获取多语言
   *
   * @param key
   * @param {...any} replace
   */
  getValue(key: string, ...replace: any[]): string {
    if (location.search.includes('showkey=1')) return key;
    if (!key) return '';
    let result = this.localeData[key.toLowerCase()] ?? '';
    if (replace.length > 0) {
      replace.forEach((v, i: number) => {
        result = result.replace(new RegExp('\\$\\{' + i + '\\}', 'g'), v);
      });
    }
    result = this.brandNameReplace(result);
    return result;
  }

  /**@brandNameReplace brand name 替换 */
  brandNameReplace(value: string): string {
    const dataUrls: string[] = [];
    const protectedValue = value.replace(this.dataUrlPattern, (dataUrl) => {
      const index = dataUrls.push(dataUrl) - 1;
      return `__BRAND_SAFE_DATA_URL_${index}__`;
    });
    const replacedValue = this.replaceBrandName(protectedValue);

    return replacedValue.replace(this.dataUrlPlaceholderPattern, (_, index) => dataUrls[Number(index)] ?? '');
  }

  private replaceBrandName(value: string): string {
    return value.replace(/({\s*Brand\s*Name\s*})|({\s*Brand\s*})|(x{3,})/gi, this.localeData['brand_name'] ?? '');
  }
}
